import React, { Component } from 'react'
import './../components/Topbar/Topbar.scss'
import { ReactComponent as LineWidth } from './../assets/icons/lineWidth.svg'
import { ReactComponent as Bold } from './../assets/icons/boldStyle.svg';
import { ReactComponent as Paint } from './../assets/icons/paint.svg';
import { ReactComponent as Stroke } from './../assets/icons/stroke.svg';
import { ReactComponent as PaintFormate } from './../assets/icons/paintFormate.svg';
import { connect } from "react-redux";
import style from './TextDecor.module.scss';
import { saveDrawing, textSelected, enablePaintFormatting, selectTool } from "./../actions/wizard";

class TextDecor extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            decorColorOpen: false,
            decorStrokeOpen: false,
            color: 'black',
            font: '5',
            subTab: 'color',
        }
    }

    updateTextProp = (obj) => {
        let color, font, Case;
        let activeObject = this.props?.fabricInstance?.getActiveObject();        
        
        if (obj.type === 'color') {
            this.setState({ color: obj.val });
            color = obj.val;
            font = this.state.font;
            if (this.props.isTextSelected) {
                activeObject.set('fill', color);
            }
            else if(activeObject) {
                if(activeObject?.type === "group") {
                    let activeGroup = this.props?.fabricInstance?.getActiveObjects();
                    activeGroup?.[0]?._objects?.forEach(function(object) {                        
                        object.set('stroke', color)
                        if(["triangle", "text"].includes(object?.type)) {
                            object.set('fill', color)
                        }
                    });
                } else {
                    activeObject.set('stroke', color)
                }
            }
        }
        else if (obj.type === 'font') {
            this.setState({ font: obj.val });
            color = this.state.color;
            font = obj.val;
            activeObject?.set('fontSize', font);
        }
        else {
            color = this.state.color
            font = this.state.font;
            Case = activeObject.fontWeight === 'bold' ? "normal" : "bold";
            activeObject?.set('fontWeight', Case);
        }
        let canvas = this.props.fabricInstance;
        canvas.renderAll();
        this.props.saveDrawing();
    }

    selectPaintDetails = () => {
        let activeObject = this.props?.fabricInstance.getActiveObject();        
        if(activeObject && activeObject?.type.includes('text') && !this.props.paintFormatting) {
            this.props.enablePaintFormatting(activeObject)
        } else {
            this.props.enablePaintFormatting(false)
        }
    }


    render() {
        const { isTextSelected, paintFormatting, selectedTool } = this.props;
        const { decorColorOpen, decorStrokeOpen, subTab, color } = this.state;
        const disableTool = this.props.pageDetails?.pageType === 'RFQ'
        return (
            <div className={`${style.textDecor_container} ${disableTool? 'toolBarDisabledIcon': '' }`} >
                <div>
                    <Paint onClick={() => this.props.selectTool(selectedTool === 'COLOR_OPTION' ? '' : 'COLOR_OPTION')} />
                    {
                        selectedTool === 'COLOR_OPTION' ? <div className={style.decor_container}>
                            {
                                <div className={style.decor_options}>
                                    <div className={style.decor_tab}>
                                        <p onClick={() => this.setState({ subTab: 'color' })} className={subTab === 'color' ? style.activeTab : ''}>Color</p>
                                        <p onClick={() => this.setState({ subTab: 'patterns' })} className={subTab === 'patterns' ? style.activeTab : ''}>Patterns</p>
                                    </div>
                                    <div className={style.colors_tab}>
                                        <div className={color == 'red' ? style.active_color : ''} onClick={(e) => this.updateTextProp({ val: 'red', type: 'color' })}><p style={{ backgroundColor: 'red' }}></p></div>
                                        <div className={color == '#B21CE7' ? style.active_color : ''} onClick={(e) => this.updateTextProp({ val: '#B21CE7', type: 'color' })}><p style={{ backgroundColor: '#B21CE7' }}></p></div>
                                        <div className={color == 'black' ? style.active_color : ''}  onClick={(e) => this.updateTextProp({ val: 'black', type: 'color' })}><p style={{ backgroundColor: 'black' }}></p></div>
                                        <div className={color == '#E7C71C' ? style.active_color : ''} onClick={(e) => this.updateTextProp({ val: '#E7C71C', type: 'color' })}><p style={{ backgroundColor: '#E7C71C' }} ></p></div>
                                        <div className={color == '#228B22' ? style.active_color : ''} onClick={(e) => this.updateTextProp({ val: '#228B22', type: 'color' })}><p style={{ backgroundColor: '#228B22' }}></p></div>
                                        <div className={color == 'blue' ? style.active_color : ''}  onClick={(e) => this.updateTextProp({ val: 'blue', type: 'color' })}><p style={{ backgroundColor: 'blue' }}></p></div>
                                        <div className={color == 'brown' ? style.active_color : ''}  onClick={(e) => this.updateTextProp({ val: 'brown', type: 'color' })}><p style={{ backgroundColor: 'brown' }}></p></div>
                                    </div>
                                </div>
                            }
                        </div> : ''
                    }
                </div>
                <div>
                    <Stroke onClick={() => this.props.selectTool(selectedTool === 'SHAPE_OPTION' ? '' : 'SHAPE_OPTION')} />
                    {
                        selectedTool === 'SHAPE_OPTION' ? <div className={style.decor_container} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '8px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                                <div style={{ padding: '4px' }}><LineWidth></LineWidth></div>
                                <div style={{ padding: '4px' }}>
                                    <select value={this.props.fabricInstance?.getActiveObject()?.fontSize} onChange={(e) => this.updateTextProp({ val: e.target.value, type: 'font' })}>
                                        <option value={4}>4px</option>
                                        <option value={8}>8px</option>
                                        <option value={12}>12px</option>
                                        <option value={16}>16px</option>
                                        <option value={20}>20px</option>
                                        <option value={24}>24px</option>
                                        <option value={28}>28px</option>
                                        <option value={32}>32px</option>
                                    </select>
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                                <div style={{ padding: '4px' }}><Bold></Bold></div>
                                <div style={{ padding: '4px' }}>
                                    <select value={this.props.fabricInstance?.getActiveObject()?.fontWeight} onChange={(e) => this.updateTextProp({ val: e, type: 'case' })}>
                                        <option value={'normal'}>Normal</option>
                                        <option value={'bold'}>Solid</option>
                                    </select>
                                </div>
                            </div>
                        </div> : ''
                    }
                </div>
                <div className={paintFormatting ? style.enableFormatting_tool : style.paintFormatting_tool} onClick={() => this.selectPaintDetails()}>
                    <PaintFormate />
                </div>
            </div>
        )
    }
}

export default connect(
    (state: any) => ({
        isTextSelected: state.wizard.isTextSelected,
        fabricInstance: state.wizard.fabricInstance,
        paintFormatting: state.wizard.paintFormatting,
        selectedTool:state.wizard.selectedTool,
        pageDetails: state.wizard.pageDetails,
    }),
    {
        saveDrawing,
        textSelected,
        enablePaintFormatting,
        selectTool
    }
)(TextDecor);
